import { render, staticRenderFns } from "./MensagemEmailSignatario.vue?vue&type=template&id=887be136"
import script from "./MensagemEmailSignatario.vue?vue&type=script&lang=js"
export * from "./MensagemEmailSignatario.vue?vue&type=script&lang=js"
import style0 from "./MensagemEmailSignatario.vue?vue&type=style&index=0&id=887be136&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports